export default __webpack_public_path__ + "static/media/withdraw-ecredit-step4.edf41505.png";